module.exports = __webpack_public_path__ + "static/media/liveIcon.ddd532a4.svg";